import { gql } from "@apollo/client";

export const GetStockCategories = gql`
  query GetStockCategories(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $orderBy: AtsStckCategoryOrder
    $name: String
  ) {
    GetStockCategories(
      token: $token
      after: $after
      customer_id: $customer_id
      first: $first
      orderBy: $orderBy
      where: { or: [{ categoryNameContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          categoryName
          slNo
          customerID
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;


export const GetStockCategoryForAutocomplete = gql`
  query GetStockCategories(
    $token: String!
    $after: Cursor
    $first: Int
    $customer_id: ID!
    $orderBy: AtsStckCategoryOrder
    $name: String
  ) {
    GetStockCategories(
      token: $token
      after: $after
      customer_id: $customer_id
      first: $first
      orderBy: $orderBy
      where: { or: [{ categoryNameContainsFold: $name }] }
    ) {
      edges {
        node {
          id
          categoryName
         
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
    }
  }
`;

//By Ids

export const GetCategoryNodeById = gql`
  query GetCategoryNodeById($id: ID!, $token:String!) {
    node(id: $id, token:$token) {
      id
      ... on AtsStckCategory {
          categoryName
          slNo
          customerID
      }
    }
  }
`;
